import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import QuestionsContainer from '../QuestionsContainer';
import QuestionnaireNavigationButtons from '../QuestionnaireNavigationButtons';
import { analyticsTrack } from '../../../analyticsUtils';
import { getRequest } from '../../../requestUtils';
import './Questionnaire.scss';
import '../../ConsultantOnboarding/Finish/Finish.scss';
var flatten = function flatten(arr) {
  return arr.reduce(function (flat, next) {
    return flat.concat(next);
  }, []);
};
var getSteps = function getSteps(object) {
  var flattened = flatten(Object.values(object));
  var steps = flattened.reduce(function (filtered, option) {
    if (!filtered.includes(option.category)) {
      filtered.push(option.category);
    }
    return filtered;
  }, []);
  return steps;
};
var questionHeader = [{
  header: 'About',
  text: 'Clora sends you projects that align with your level of experience'
}, {
  header: 'Past Experience',
  text: 'Your past experience is one of the most important criteria that employers review when they evaluate candidates.'
}, {
  header: 'Education',
  text: 'Clora sends you projects that align with the degrees you hold'
}, {
  header: 'Functional Areas',
  text: 'Matching functional areas is one of the primary ways we refine project suggestions for you'
}, {
  header: 'Therapeutic Areas',
  text: 'We improve project suggestions by leveraging therapeutic areas'
}, {
  header: 'Industries and Product Technologies',
  text: "Clora's technology will leverage industries, phases, and product types to further enrich your project suggestions"
}, {
  header: 'Preferences',
  text: "Clora's technology will leverage industries, phases, and product types to further enrich your project suggestions"
}];
var Questionnaire = /*#__PURE__*/function (_Component) {
  function Questionnaire(props) {
    var _this;
    _classCallCheck(this, Questionnaire);
    _this = _callSuper(this, Questionnaire, [props]);
    _this.state = {
      currentPage: parseInt(props.page, 10) || 0,
      finish: props.finish || false,
      percentage: null,
      questionnaireLoaded: false
    };
    _this.nextPage = _this.nextPage.bind(_this);
    _this.previousPage = _this.previousPage.bind(_this);
    _this.renderQuestionOrFinish = _this.renderQuestionOrFinish.bind(_this);
    _this.handleUpdatePage = _this.handleUpdatePage.bind(_this);
    _this.loadButtons = _this.loadButtons.bind(_this);
    return _this;
  }
  _inherits(Questionnaire, _Component);
  return _createClass(Questionnaire, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateCompletionPercentage();
      window.questionsContainer = this;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var page = this.props.page;
      this.handleUpdatePage(page, prevProps.page);
    }
  }, {
    key: "handleUpdatePage",
    value: function handleUpdatePage(page, prevPage) {
      if (page !== prevPage) {
        this.setState({
          currentPage: page,
          questionnaireLoaded: false
        });
      }
    }
  }, {
    key: "handleShowFinishModal",
    value: function handleShowFinishModal(questionKey) {
      var _this$props = this.props,
        questionnaireName = _this$props.questionnaireName,
        handleShowFinishPage = _this$props.handleShowFinishPage;
      this.updateCompletionPercentage();
      handleShowFinishPage(true);
      analyticsTrack('Clicked on Save & Exit', {
        location: questionnaireName === 'Consultant Onboarding' ? 'Onboarding Flow' : questionnaireName,
        question: questionKey
      });
    }
  }, {
    key: "previousPage",
    value: function previousPage(questionKey, position) {
      var _this$props2 = this.props,
        userId = _this$props2.userId,
        questionnaireName = _this$props2.questionnaireName,
        handlePreviousStep = _this$props2.handlePreviousStep,
        setPreviousState = _this$props2.setPreviousState;
      var _this$state = this.state,
        currentPage = _this$state.currentPage,
        finish = _this$state.finish;
      analyticsTrack('Clicked on Previous', {
        location: questionnaireName === 'Consultant Onboarding' ? 'Onboarding Flow' : questionnaireName,
        question: questionKey,
        step: questionHeader[currentPage].header,
        position: position,
        userId: userId
      });
      if (currentPage === 0) {
        setPreviousState();
        handlePreviousStep();
      } else if (currentPage > 0) {
        currentPage -= 1;
        finish = false;
        handlePreviousStep();
      }
      this.setState({
        currentPage: currentPage,
        finish: finish
      });
      window.scrollTo(0, 0);
    }
  }, {
    key: "nextPage",
    value: function nextPage(questionKey, position) {
      var _this$state2 = this.state,
        currentPage = _this$state2.currentPage,
        finish = _this$state2.finish;
      var _this$props3 = this.props,
        userId = _this$props3.userId,
        questionnaire = _this$props3.questionnaire,
        questionnaireName = _this$props3.questionnaireName,
        handleNextStep = _this$props3.handleNextStep,
        handleShowFinishPage = _this$props3.handleShowFinishPage;
      if (currentPage !== questionnaire.length - 1) {
        currentPage += 1;
        handleNextStep();
      } else {
        finish = true;
        handleShowFinishPage(true);
      }
      this.setState({
        currentPage: currentPage,
        finish: finish
      });
      window.scrollTo(0, 0);
      analyticsTrack('Clicked on Next', {
        location: questionnaireName === 'Consultant Onboarding' ? 'Onboarding Flow' : questionnaireName,
        question: questionKey,
        step: finish ? questionHeader[currentPage].header : questionHeader[currentPage - 1].header,
        position: position,
        userId: userId
      });
    }
  }, {
    key: "updateCompletionPercentage",
    value: function updateCompletionPercentage() {
      var _this2 = this;
      var _this$props4 = this.props,
        profileQuestionnaireId = _this$props4.profileQuestionnaireId,
        userId = _this$props4.userId;
      getRequest("/users/".concat(userId, "/completion_percentage?questionnaire_id=").concat(profileQuestionnaireId)).then(function (response) {
        _this2.setState({
          percentage: response.data.value
        });
      });
    }
  }, {
    key: "loadButtons",
    value: function loadButtons() {
      this.setState({
        questionnaireLoaded: true
      });
    }
  }, {
    key: "renderNavigationButtons",
    value: function renderNavigationButtons(questionKey, position) {
      var _this3 = this;
      var _this$state3 = this.state,
        currentPage = _this$state3.currentPage,
        finish = _this$state3.finish;
      var _this$props5 = this.props,
        questionnaire = _this$props5.questionnaire,
        onboardType = _this$props5.onboardType;
      return /*#__PURE__*/React.createElement(QuestionnaireNavigationButtons, {
        steps: getSteps(questionnaire),
        activeStep: questionnaire[currentPage] && questionnaire[currentPage][0].category || 'Next',
        lastStep: currentPage === 6,
        atBeginning: currentPage === 0,
        finish: finish,
        handleNextStep: function handleNextStep() {
          return _this3.nextPage(questionKey, position);
        },
        handlePreviousStep: function handlePreviousStep() {
          return _this3.previousPage(questionKey, position);
        },
        workflow: onboardType,
        position: position
      });
    }
  }, {
    key: "renderQuestionOrFinish",
    value: function renderQuestionOrFinish() {
      var _this$state4 = this.state,
        currentPage = _this$state4.currentPage,
        questionnaireLoaded = _this$state4.questionnaireLoaded;
      var _this$props6 = this.props,
        questionnaire = _this$props6.questionnaire,
        questionnaireName = _this$props6.questionnaireName,
        questionableId = _this$props6.questionableId,
        questionableType = _this$props6.questionableType,
        csrfToken = _this$props6.csrfToken,
        owner = _this$props6.owner,
        suggestedAnswers = _this$props6.suggestedAnswers,
        userId = _this$props6.userId,
        updateMenu = _this$props6.updateMenu,
        handleMenuUpdate = _this$props6.handleMenuUpdate;
      var questionnaireQuestionIds = questionnaire[currentPage].map(function (x) {
        return x.id;
      });
      var categoryName = questionnaire[currentPage][0].category;
      var questionKey = questionnaire[currentPage][0].question_key;
      return /*#__PURE__*/React.createElement("div", {
        key: currentPage
      }, /*#__PURE__*/React.createElement("div", {
        className: "questionnaire-nav"
      }, /*#__PURE__*/React.createElement("div", {
        className: "questionnaire-nav-container"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h5", {
        className: "category-name"
      }, questionHeader[currentPage].header), /*#__PURE__*/React.createElement("div", {
        className: "header-subtext"
      }, questionHeader[currentPage].text)), this.renderNavigationButtons(questionKey, 'top'))), /*#__PURE__*/React.createElement(QuestionsContainer, {
        questionnaireName: questionnaireName,
        questionIds: categoryName === 'Education' ? [questionnaireQuestionIds[0]] : questionnaireQuestionIds,
        questionableId: questionableId,
        questionableType: questionableType,
        csrfToken: csrfToken,
        owner: owner,
        userId: userId,
        suggestedAnswers: suggestedAnswers,
        saveOnChange: true,
        updateMenu: updateMenu,
        handleMenuUpdate: handleMenuUpdate,
        questionHeader: questionHeader[currentPage].header,
        loadButtons: this.loadButtons
      }), questionnaireLoaded && this.renderNavigationButtons(questionKey, 'bottom'));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "main-container"
      }, this.renderQuestionOrFinish());
    }
  }]);
}(Component);
Questionnaire.propTypes = {
  questionnaireName: PropTypes.string.isRequired,
  questionnaire: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  questionableId: PropTypes.number.isRequired,
  questionableType: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  owner: PropTypes.bool,
  onboardType: PropTypes.string.isRequired,
  page: PropTypes.number,
  suggestedAnswers: PropTypes.shape({}),
  finish: PropTypes.bool,
  userId: PropTypes.string,
  profileQuestionnaireId: PropTypes.number,
  handleNextStep: PropTypes.func.isRequired,
  setPreviousState: PropTypes.func.isRequired,
  handlePreviousStep: PropTypes.func.isRequired,
  updateMenu: PropTypes.bool.isRequired,
  handleMenuUpdate: PropTypes.func.isRequired,
  handleShowFinishPage: PropTypes.func.isRequired
};
Questionnaire.defaultProps = {
  page: null,
  owner: false,
  suggestedAnswers: null,
  finish: false,
  userId: null,
  profileQuestionnaireId: null
};
export default Questionnaire;